import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class LiveUpdateService {
	/* eslint-disable @typescript-eslint/no-explicit-any */
	public data$ = new BehaviorSubject<any>(null)

	setData<T>(value: T) {
		this.data$.next(value)
	}

	getData<T>(): Observable<T> {
		return this.data$.asObservable() as Observable<T>
	}
}
